import React, { Component } from 'react'
import styles from './ButtonRound.module.css'
import PropTypes from 'prop-types'

/**
 * @extends {React.Component<ButtonRound.propTypes>}
 */ 
class ButtonRound extends Component {
    render() {
        const { 
            className,
            onClick,
            disabled, 
            type,
            children
        } = this.props

        return (
            <button 
                className={`${styles['btn-round']} ${className}`}
                onClick={onClick}
                disabled={disabled}
                type={type}
            >
                { children }
            </button>
        )
    }
}

ButtonRound.defaultProps = {
    className: '',
    onClick: undefined,
    disabled: false
}

ButtonRound.propTypes = {
    /**
     * @type {string}
     */
    className: PropTypes.string,

    /**
     * @type {React.MouseEvent<HTMLButtonElement, MouseEvent>}
     */
    onClick: PropTypes.func,

    /**
     * @type {string}
     */
    type: PropTypes.string,

    /**
     * @type {boolean}
     */
    disabled: PropTypes.bool
}

export default ButtonRound